import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import Cookies from 'js-cookie';

import methods from '@/apis/constants/methods';
import { CSRF_TOKEN_COOKIE_KEY } from './constants/cookies';

type Context = {
  params?: Record<string, any>;
  customConfig: {
    headers?: Record<string, any>;
    withCredentials?: Boolean;
    Authorization?: string;
  };
};

export const getTokenFromUrl = () => {
  let params = new URL(document.location.toString()).searchParams;

  let token = params.get('token');

  return token || '';
};

export const _getBaseConfig = (
  url: string,
  method: string,
  ctx: Context | any = {}
) => {
  const { customConfig = {} } = ctx;

  const headers: any = {
    'X-CSRFToken': Cookies.get(CSRF_TOKEN_COOKIE_KEY) ?? '',
    'Content-Type': 'application/json'
  };

  if (customConfig.Authorization) {
    headers.Authorization = customConfig.Authorization;
    delete customConfig.Authorization;
  }

  const baseConfig = {
    headers,
    url,
    method,
    withCredentials: true,
    params: null,
    ...customConfig
  };

  return baseConfig;
};

export const get = <TResponse = any>(url: string, ctx?: Context) =>
  axios<TResponse>({
    ..._getBaseConfig(url, methods.GET, ctx)
  });

export const post = <TResponse = any>(url: string, data: any, ctx: any = {}) =>
  axios<TResponse>({
    ..._getBaseConfig(url, methods.POST, ctx),
    data
  });

export const patch = <TResponse = any>(url: string, data: any) =>
  axios<TResponse>({
    ..._getBaseConfig(url, methods.PATCH),
    data
  });

export const deleteRequest = <TResponse = any>(url: string) =>
  axios<TResponse>({
    ..._getBaseConfig(url, methods.DELETE)
  });
